<template>
    <div class="c-dashboard-row -week-sticky -week-header"
        :data-component-name="$options.name"
    >
        <MoreFilters 
            @set-more-filters="$emit('set-more-filters', $event)"
        />
        <div class="c-dashboard-row">
            <div class="c-dashboard__item -control -left">
                <RangePicker 
                    v-model="weekrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                />
                <button 
                    class="c-dashboard-control -previous-week"
                    @click="$emit('set-current-date', prevWeek)"
                >
                    <SvgIcon name="arrow-alt-left" />
                </button>
            </div>
            <div class="c-dashboard__item -week">
                <div class="c-dashboard-day__wrap"
                    v-bind:key="index" v-for="(weekday, index) in weekdays"
                >
                    <div class="c-dashboard-day__overview">
                        <div class="c-dashboard-day__date">
                            <div class="c-dashboard-day__status">
                                <span class="o-status-pin -confirmed">
                                    <!-- STATUS CLASS .-draft,.-published,.-alert,.-confirmed,.-completed -->
                                </span>
                            </div>
                            {{ weekday.dayOfWeekStr.short }} {{ weekday.day }} {{ weekday.monthStr.short.toLowerCase() }} {{ weekday.date.getFullYear() }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-dashboard__item -control -right">
                <RangePicker 
                    v-model="weekrange.str"
                    @set-current-date="$emit('set-current-date', $event)"
                />
                <button
                    class="c-dashboard-control -next-week"
                    @click="$emit('set-current-date', nextWeek)"
                >
                    <SvgIcon name="arrow-alt-right" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDatesBetween, dayOfWeekStr, monthStr, dayStr} from "@/js/dateUtilities"
    import moment from 'moment';
    import MoreFilters from '@/components/nav/MoreFilters'

    export default{
        name: 'WeekViewFooter.vue',
        components: {
            MoreFilters
        },
        props: {
            currentDate: String,
            weekrange: Object
        },
        data(){
            return {
                dateOffset: parseInt(this.$generalSettings.settings.firstDayOfWeek)+0
            }
        },
        mounted(){
            document.onkeydown = function(e){
                if (e.keyCode == 37 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.prevWeek)
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && !e.shiftKey) this.$emit('set-current-date', this.nextWeek)
                if (e.keyCode == 37 && e.altKey && e.ctrlKey && e.shiftKey) {
                    this.dateOffset--
                    if(this.dateOffset<0){
                        this.dateOffset=6
                    }
                    this.$emit('set-current-date', moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD'))
                    this.$emit('set-date-offset', this.dateOffset)
                }
                if (e.keyCode == 39 && e.altKey && e.ctrlKey && e.shiftKey){
                    this.dateOffset++
                    if(this.dateOffset>6){
                        this.dateOffset=0
                    }
                    this.$emit('set-current-date', moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD'))
                    this.$emit('set-date-offset', this.dateOffset)
                }
            }.bind(this)
        },
        beforeDestroy() {
            document.onkeydown = null
        },
        computed: {
            prevWeek(){
                return moment(this.currentDate).subtract(7, 'days').format('YYYY-MM-DD');
            },
            nextWeek(){
                return moment(this.currentDate).add(7, 'days').format('YYYY-MM-DD');
            },
            weekdays(){
                let dateRange=getDatesBetween(this.weekrange.obj.from, this.weekrange.obj.to)
                let weekdays=[]

                dateRange.forEach(function(date){
                    weekdays.push({
                        date: date,
                        day: dayStr(date.getDate()),
                        dayOfWeekStr: dayOfWeekStr(date),
                        monthStr: monthStr(date)
                    })
                })
                return weekdays
            },
            // firstDayOfweek(){
            //     if(this.currentDate) return moment(this.currentDate).startOf('week');

            //     return 'asdasd';
            // }
        }
    }
</script>